const en_master_supplier = {
    add: "add supplier",
    address: "supplier address",
    edit: "edit supplier",
    email: "supplier email",
    fax: "supplier fax",
    name: "supplier name",
    phone: "supplier phone",
    pic: "supplier PIC",
    upload: "upload supplier",

    form: {
        ppn_label: "Enable to use PPN",
        upload_title: "input supplier data",
        coa_debit: "debit COA",
        coa_dp: "Down Payment (DP) COA",
    },

    message: {
        note_upload: "NOTE: Only Excel file formats can be uploaded!",
        note_excel: "Download the supplier Excel template.",
        note_term_title: "File Requirements:",
        note_term_1: "Use the provided template.",
        note_term_2: "Fields marked with '*' are required",
        note_term_3: "Supplier Name: Must be filled in. If the supplier already exists in the database, it cannot be added again. Example: supplier1, supplier2, supplier3.",
        note_term_4: "PPN: Enter 1 if PPN is applicable, or 0 if PPN is not applicable.",
        note_term_5: "PIC: The person who can be contacted.",
    },

    error: {
        create: "Failed to create supplier.",
        delete: "Failed to delete supplier.",
        edit: "Failed to update supplier.",
    },

    success: {
        create: "Supplier created successfully.",
        delete: "Supplier deleted successfully.",
        edit: "Supplier updated successfully.",
    },
}

export default en_master_supplier;